<div class="main-header">
  <div class="header-top-row">
    <div class="left-options">
      <div class="logo-mobile-cont">
        <div class="logo">
          <a [routerLink]="'/'">
            <img alt="Checkups" title="Checkups" [src]="brandService.assets().logo" />
          </a>
          @if (environment !== 'PROD') {
            <span class="environment">{{ environment }}</span>
          }
        </div>
        @if (isLoggedIn() && isMobileView() && showCampaignButton) {
          <div class="mobile-button-row">
            <p-button class="btn-mobile-campaign" [label]="'CampaignMenu' | translate" (click)="toggleMobileMenu()">
              <span class="material-symbols-outlined">menu_book</span>
            </p-button>
          </div>
        }
      </div>

      @if (isLoggedIn()) {
        <p-menubar #menubar autoDisplay="true" autoHide="true" [model]="items" [autoHideDelay]="100">
          <ng-template #item let-item>
            <a class="p-menubar-item-link" routerLinkActive="active-menu-item" [routerLink]="item.routerLink" [routerLinkActiveOptions]="{ exact: false }">
              <i class="material-symbols-outlined"> {{ item.icon }} </i>
              @if (isLoggedIn() && currentUser?.userName) {
                <span>{{ item.label | translate }}</span>
              } @else {
                <p-skeleton width="5rem" height="1.5rem" styleClass="ml-3 p-menubar" />
              }
              @if (item.items) {
                <span class="material-symbols-outlined icon-chevron-down">keyboard_arrow_down</span>
              }
            </a>
          </ng-template>
        </p-menubar>
      }
    </div>
  </div>

  <app-connection-warning />

  <div class="right-options">
    @if (!loading()) {
      @if (isLoggedIn() && currentUser?.userName) {
        @if (brandService.indeterminate && !isExternal) {
          <app-brand-selector />
        }
        @if (!isExternal) {
          <div class="user-notifications-wrapper">
            <div class="user-notifications" (click)="notificationsPanel.toggle($event)" (keydown.enter)="notificationsPanel.toggle($event)">
              <span class="material-symbols-outlined"> notifications </span>
              @if (unreadNotificationsCount > 0) {
                <span class="unread">{{ unreadNotificationsCount }}</span>
              }
            </div>

            <p-popover #notificationsPanel appendTo="body" styleClass="panel-notifications">
              <div class="notifications-popover">
                @if (notificationItems.length > 0) {
                  @for (notification of primaryNotificationItems; track notification.campaignInstanceGuid) {
                    <div class="notification-box" (click)="onNotificationClick(notification, notificationsPanel)" (keydown.enter)="onNotificationClick(notification, notificationsPanel)">
                      <div class="notification-info">
                        <div class="flex gap-2">
                          <span class="material-symbols-outlined">mark_as_unread</span>
                          <h6>
                            {{ notification.campaignName || notification.campaignInstanceGuid }}
                            <span class="notification-pill">{{ notification.unreadCount }}</span>
                          </h6>
                        </div>

                        <p>{{ notification.participantName || ('NoMessagesYet' | translate) }} - {{ notification.participantNif || '---' }}</p>
                      </div>
                    </div>
                  }

                  @if (observerNotificationItems.length > 0) {
                    @if (primaryNotificationItems.length > 0) {
                      <div class="notification-divider"></div>
                    }
                    @for (notification of observerNotificationItems; track notification.campaignInstanceGuid) {
                      <div class="notification-box observer" (click)="onNotificationClick(notification, notificationsPanel)" (keydown.enter)="onNotificationClick(notification, notificationsPanel)">
                        <div class="notification-info">
                          <div class="flex gap-2">
                            <span class="material-symbols-outlined">visibility</span>
                            <h6>
                              {{ notification.campaignName || notification.campaignInstanceGuid }}
                              <span class="notification-pill">{{ notification.unreadCount }}</span>
                            </h6>
                          </div>

                          <p>{{ notification.participantName || ('NoMessagesYet' | translate) }} - {{ notification.participantNif || '---' }}</p>
                        </div>
                      </div>
                    }
                  }
                } @else {
                  <div class="notification-box empty">
                    <div class="notification-info">
                      <div class="flex gap-2">
                        <span class="material-symbols-outlined">mark_as_unread</span>
                        <h6>{{ 'NoMessagesYet' | translate }}</h6>
                      </div>
                      <p>{{ 'NoMessagesYet' | translate }}</p>
                    </div>
                  </div>
                }
              </div>
            </p-popover>
          </div>
        }

        <div class="user-profile-wrapper">
          <div class="user-profile" (click)="userPanel.toggle($event)" (keydown.enter)="userPanel.toggle($event)">
            <span>{{ getInitials(currentUser?.userName) }}</span>
          </div>
          <p-popover #userPanel appendTo="body" styleClass="panel-users">
            <div class="user-popover">
              <div class="user-header">
                <i class="material-symbols-outlined"> account_circle </i>
                <a class="user-avatar" routerLink="/profile">{{ currentUser?.userName }}</a>
                <span class="user-current-user-email">{{ currentUser?.userEmail }}</span>
              </div>

              <div class="user-body">
                <ul>
                  @for (group of groupByPositionInvariantName(); track group.positionInvariantName) {
                    <li class="user-role">{{ group.positionInvariantName | translate }}</li>
                    <ul>
                      @for (typeGroup of group.ouTypeGroups; track typeGroup.ouTypeInvariantName) {
                        <li class="user-role user-ou-type">{{ typeGroup.ouTypeInvariantName | translate }}</li>
                        <ul>
                          @for (ou of typeGroup.ous; track ou.name) {
                            <li class="user-role">
                              @if (ou.route) {
                                <a class="user-role-link" [routerLink]="ou.route" (click)="userPanel.hide()">{{ ou.name }}</a>
                              } @else {
                                {{ ou.name }}
                              }
                            </li>
                          }
                        </ul>
                      }
                    </ul>
                  }
                </ul>
              </div>

              <i class="custom-hr"></i>

              <div class="user-footer">
                <div class="user-clear-cache" (click)="referenceDataApi.clearCache()" (keydown)="referenceDataApi.clearCache()">
                  <span role="button">{{ 'RefreshCache' | translate }}</span>
                </div>
                <div class="user-logout" (click)="authService.logout()" (keydown)="authService.logout()">
                  <i class="material-symbols-outlined"> logout </i>
                  <span role="button">{{ 'Logout' | translate }}</span>
                </div>
              </div>
            </div>
          </p-popover>
        </div>
      }
      <div class="select-language">
        <p-button (click)="languagesPanel.toggle($event)">
          {{ languageCodeFromCulture() }}
        </p-button>
        <p-popover #languagesPanel appendTo="body" styleClass="panel-language">
          <ul>
            @for (language of availableLanguages; track language.languageCode) {
              <li (click)="onLanguageSelect(language, languagesPanel)" (keydown.enter)="onLanguageSelect(language, languagesPanel)">
                <svg>
                  <use [attr.href]="'svg/icons-flag.svg#flag-' + getFlagFile(language)" />
                </svg>
                <span>{{ language.cultureEnglishName! | translate }}</span>
              </li>
            }
          </ul>
        </p-popover>
      </div>
    } @else if (loading()) {
      <div class="user-profile-wrapper">
        <p-skeleton shape="circle" size="3rem" styleClass="user-profile mr-2" />
      </div>
      <div class="select-language">
        <p-skeleton width="2.5rem" height="1.5rem" />
      </div>
    }
  </div>
</div>
